import { FC, useMemo } from 'react';

const PasswordEyeIcon: FC = () => {
  return useMemo(() => {
    return (
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0 w-4 aspect-square self-center cursor-pointer"
      >
        <g clipPath="url(#clip0_1812_46502)">
          <mask
            id="mask0_1812_46502"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="17"
            className="luminanceMaskType"
          >
            <rect y="0.5" width="16" height="16" fill="white" />
          </mask>
          <g mask="url(#mask0_1812_46502)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16 8.5C16 8.5 13 3 8 3C3 3 0 8.5 0 8.5C0 8.5 3 14 8 14C13 14 16 8.5 16 8.5ZM1.173 8.5C1.65652 9.23488 2.21265 9.91931 2.83301 10.543C4.12 11.832 5.88 13 8 13C10.12 13 11.879 11.832 13.168 10.543C13.7884 9.91931 14.3445 9.23487 14.828 8.5C14.3445 7.76512 13.7884 7.08068 13.168 6.457C11.879 5.168 10.119 4 8 4C5.88 4 4.121 5.168 2.832 6.457C2.21164 7.08069 1.65551 7.76513 1.172 8.50001L1.173 8.5Z"
              fill="#323134"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 6C6.61929 6 5.5 7.11928 5.5 8.49999C5.5 9.8807 6.61928 11 7.99999 11C9.3807 11 10.5 9.88072 10.5 8.50001C10.5 7.1193 9.38072 6.00001 8.00001 6H8ZM4.5 8.5C4.5 7.24957 5.1671 6.09413 6.25 5.46891C7.3329 4.8437 8.66709 4.8437 9.75 5.46891C10.8329 6.09412 11.5 7.24957 11.5 8.5C11.5 9.75043 10.8329 10.9059 9.75 11.5311C8.6671 12.1563 7.3329 12.1563 6.25 11.5311C5.1671 10.9059 4.5 9.75043 4.5 8.5V8.5Z"
              fill="#323134"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1812_46502">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }, []);
};

export default PasswordEyeIcon;
